import { Injectable } from '@angular/core';
import { Router} from '@angular/router';

@Injectable()
export class RouterExtensionsService {

  private currentUrl: string;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
  }

  public getCurrentUrl(): string {
    var value = localStorage.getItem("redeployment_currentUrl");
    if (value) {
      return value.toString();
    }
    return "";
  }

  public setCurrentUrl(url: string) {
    localStorage.setItem("redeployment_currentUrl", url);
  }

}
